import { useMainTabs } from "@/hooks";
import { cn, isContentTemplate } from "@/utils";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { Header } from "@/app/modules/Navigation";
import { useScrollPosition } from "@/providers/context";
import { ContentTab } from "./ContentTab.tsx";

interface ContentSubTabProps {
  tabId: string;
  subTabId: string;
}

export const ContentSubNav = ({ tabId, subTabId }: ContentSubTabProps) => {
  const { mainTabs, collectionsById } = useMainTabs();
  const navigate = useNavigate();
  const { resetScrollPositions } = useScrollPosition();

  const mainTab = useMemo(() => {
    return mainTabs?.find((t) => t.TabId === parseInt(tabId));
  }, [mainTabs, tabId]);

  if (!mainTabs || !collectionsById) {
    return null;
  }

  return (
    <div className="text-item-primary">
      <Header
        className="p-[28px]"
        content={
          <div className="mb-[0px] flex w-full justify-start gap-[16px]">
            {mainTab?.Items.map((i, idx) => {
              const active = subTabId === i.ChildId;
              const subtabCol = collectionsById[parseInt(i.ChildId)];
              if (!subtabCol) {
                console.debug(
                  "Subtab Ignored, Collection not found in MainTabs",
                  {
                    tabId: i.ChildId,
                  },
                );
                return null;
              }
              if (
                !subtabCol.TemplateId ||
                !isContentTemplate(subtabCol.TemplateId)
              ) {
                console.debug(
                  "Subtab Ignored, Template not a content template",
                  {
                    tabId: i.ChildId,
                    template: subtabCol?.TemplateId,
                  },
                );
                return null;
              }
              return (
                <div
                  key={i.ChildId}
                  data-testid={`subtab-button-${idx}`}
                  className={cn([
                    "p2-bold cursor-pointer rounded-[8px] bg-surface-secondary px-[10px] py-[6px] hover:bg-surface-tertiary",
                    active &&
                      "bg-highlightBg text-highlightPrimary hover:bg-highlightBg",
                  ])}
                  onClick={() => {
                    resetScrollPositions();
                    navigate(`/content/${tabId}/${i.ChildId}`);
                  }}
                >
                  <div className="whitespace-nowrap rounded-xl px-1">
                    {i.Title}
                  </div>
                </div>
              );
            })}
          </div>
        }
      />
      <ContentTab id={parseInt(subTabId)} />
    </div>
  );
};
